// contexts/User/index.jsx
import React, { useEffect, useCallback, createContext, useState } from 'react';
import { LOGIN } from 'store/actions';
import { useDispatch } from 'react-redux';
import { API } from 'utils/api';

export const UserContext = createContext();

// eslint-disable-next-line
const UserProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const loadUser = useCallback(async () => {
    let user = localStorage.getItem('user');
    if (user) {
      let data = JSON.parse(user);
      if (data.biz_role === 'guest') {
        localStorage.removeItem('user');
        try {
          await API.get('/api/user/logout');
        } catch (error) {
          // Local cleanup is enough for Berry pages.
        }
        dispatch({ type: LOGIN, payload: null });
        setIsUserLoaded(true);
        return;
      }
      const needsFreshUser =
        !data.biz_role ||
        (data.biz_role === 'hotel' && (!data.hotel_role || data.hotel_id === undefined || data.hotel_id === null));
      if (needsFreshUser) {
        try {
          const res = await API.get('/api/user/self');
          if (res.data?.success && res.data?.data) {
            data = res.data.data;
            localStorage.setItem('user', JSON.stringify(data));
          }
        } catch (error) {
          // Keep the stored user fallback; API interceptor handles invalid sessions.
        }
      }
      dispatch({ type: LOGIN, payload: data });
    }
    setIsUserLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <UserContext.Provider value={{ loadUser, isUserLoaded }}> {children} </UserContext.Provider>;
};

export default UserProvider;
